import { RouteProps } from '../../../types';
import {
  ArtistsScreen,
  CollectionsScreen,
  CreateArtistScreen,
  CreateCollectionScreen,
  CreateGameEventScreen,
  CreatePuzzleScreen,
  EditGameEventScreen,
  EditPuzzleScreen,
  PayoutsScreen,
  PuzzlesScreen,
  SettingsScreen,
  ViewPuzzleScreen,
} from '../pages';
import { ArtistInsightsScreen } from '../pages/ArtistInsightsScreen';
import { ColoringGridCollectionsScreen } from '../pages/ColoringGridCollectionsScreen';
import { ColoringGridsScreen } from '../pages/ColoringGridsScreen';
import { ContentPreviewScreen } from '../pages/ContentPreviewScreen';
import DailyPuzzlesScreen from '../pages/DailyPuzzlesScreen';
import { EditArtistScreen } from '../pages/EditArtistScreen';
import FirstApprovalScreen from '../pages/FirstApprovalScreen';
import { GameEventsScreen } from '../pages/GameEventsScreen';
import { InsightDetailsScreen } from '../pages/InsightDetailsScreen';
import { InsightsScreen } from '../pages/InsightsScreen';
import { ManageColoringGridScreen } from '../pages/ManageColoringGridScreen';
import { ManageStoryScreen } from '../pages/ManageStoryScreen';
import { ManageVideoPuzzleScreen } from '../pages/ManageVideoPuzzleScreen';
import PayoutRequestDetailsScreen from '../pages/PayoutRequestDetailsScreen/PayoutRequestDetailsScreen';
import PayoutRequestsScreen from '../pages/PayoutRequestsScreen/PayoutRequestsScreen';
import RevenueAnalytics from '../pages/RevenueAnalytics/RevenueAnalytics';
import RevenueArtistScreen from '../pages/RevenueArtistScreen/RevenueArtistScreen';
import RevenueByArtistScreen from '../pages/RevenueByArtistScreen/RevenueByArtistScreen';
import RevenueByPuzzleScreen from '../pages/RevenueByPuzzleScreen/RevenueByPuzzleScreen';
import RevenuePuzzleScreen from '../pages/RevenuePuzzleScreen/RevenuePuzzleScreen';
import RevenueScreen from '../pages/RevenueScreen/RevenueScreen';
import { StoriesScreen } from '../pages/StoriesScreen';
import { SubscriptionSplitScreen } from '../pages/SubscriptionSplitScreen';
import { ViewArtistScreen } from '../pages/ViewArtistScreen';
import { ViewColoringGridScreen } from '../pages/ViewColoringGridScreen';

import { DashboardRoutePath } from './path';

export const routes: RouteProps[] = [
  // This one has to stay in to force redirect to puzzles screen
  {
    path: `/approve-puzzles`,
    Component: PuzzlesScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: '/',
    Component: CreatePuzzleScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.CREATE_PUZZLE}`,
    Component: CreatePuzzleScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.CREATE_COLLECTION}`,
    Component: CreateCollectionScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.CREATE_ARTISTS}`,
    Component: CreateArtistScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.CREATE_GAME_EVENTS}`,
    Component: CreateGameEventScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.ARTISTS}`,
    Component: ArtistsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.PUZZLES}`,
    Component: PuzzlesScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.COLORING_GRIDS}`,
    Component: ColoringGridsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.COLLECTIONS}`,
    Component: CollectionsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.COLORING_GRID_COLLECTIONS}`,
    Component: ColoringGridCollectionsScreen,
    exact: true,
    type: 'Private',
  },
  // {
  //   path: `/${DashboardRoutePath.ANALYTICS}`,
  //   Component: AnalyticsScreen,
  //   exact: true,
  //   type: 'Private',
  // },
  {
    path: `/${DashboardRoutePath.SETTINGS}`,
    Component: SettingsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.SETTINGS}/${DashboardRoutePath.ACCOUNT_INFO}`,
    Component: SettingsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.SETTINGS}/${DashboardRoutePath.USERS}`,
    Component: SettingsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.EDIT_GAME_EVENTS}/:id`,
    Component: EditGameEventScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.EDIT_PUZZLE}/:id`,
    Component: EditPuzzleScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.VIEW_ARTIST}/:id`,
    Component: ViewArtistScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.EDIT_ARTIST}/:id`,
    Component: EditArtistScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.FIRST_APPROVAL}/:id`,
    Component: FirstApprovalScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.PAYOUTS}`,
    Component: PayoutsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.PUZZLES}/:id`,
    Component: ViewArtistScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.VIEW_PUZZLE}/:id`,
    Component: ViewPuzzleScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.INSIGHTS}`,
    Component: InsightsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.INSIGHT_DETAILS}/:date`,
    Component: InsightDetailsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.INSIGHTS}/${DashboardRoutePath.ARTIST_INSIGHTS}/:artistId`,
    Component: ArtistInsightsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.REVENUE}`,
    Component: RevenueScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.REVENUE}/:date/artists`,
    Component: RevenueArtistScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.REVENUE}/:date/puzzles`,
    Component: RevenuePuzzleScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.REVENUE_BY_PUZZLE}/:id`,
    Component: RevenueByPuzzleScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.REVENUE_BY_ARTIST}/:id`,
    Component: RevenueByArtistScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.PAYOUT_REQUESTS}`,
    Component: PayoutRequestsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.PAYOUT_REQUESTS}/:id`,
    Component: PayoutRequestDetailsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.REVENUE_ANALYTICS}`,
    Component: RevenueAnalytics,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.DAILY_PUZZLES}`,
    Component: DailyPuzzlesScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.GAME_EVENTS}`,
    Component: GameEventsScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.STORIES}`,
    Component: StoriesScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.MANAGE_VIDEO_PUZZLE}`,
    Component: ManageVideoPuzzleScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.MANAGE_VIDEO_PUZZLE}/:id`,
    Component: ManageVideoPuzzleScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.MANAGE_STORY}`,
    Component: ManageStoryScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.MANAGE_STORY}/:id`,
    Component: ManageStoryScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.MANAGE_COLORING_GRIDS}`,
    Component: ManageColoringGridScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.MANAGE_COLORING_GRIDS}/:id`,
    Component: ManageColoringGridScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.VIEW_COLORING_GRIDS}/:id`,
    Component: ViewColoringGridScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.CONTENT_PREVIEW_SCREEN}`,
    Component: ContentPreviewScreen,
    exact: true,
    type: 'Private',
  },
  {
    path: `/${DashboardRoutePath.SUBSCRIPTIONS_SPLIT}`,
    Component: SubscriptionSplitScreen,
    exact: true,
    type: 'Private',
  },
];
